export default "__VITE_ASSET__DSxJkn6x__"